import React from "react"
import PropTypes from "prop-types"
import { compose, withProps } from "recompact"
import TabsCrudModal from "src/components/TabsCrudModal"
import Constraints from "src/components/PlanConstraints"
import {
  PLANS_ID_CALENDAR_CONSTRAINT_URL,
  PLANS_ID_CALENDAR_MAIN_URL,
  PLANS_ID_CALENDAR_RESOURCES_URL,
  PLANS_URL,
} from "src/constants/routeNames"
import queryString from "query-string"
import entityApi from "src/hocs/entity"
import planModel from "src/models/plan"
import Item from "../Plans/Item"
import PlanResourcesModal from "../Plans/Item/PlanResourcesModal"

const enhancer = compose(
  withProps(
    props =>
      props.match.params.id !== `new` && {
        id: props.match.params.id || props.match.params.planId,
      },
  ),
  entityApi({
    to: `plan`,
    model: planModel,
    onCreate: ({ history, queryParams }) => ({ id }) => {
      history.push(`${PLANS_URL}/${id}?${queryString.stringify(queryParams)}`)
    },
  }),
  withProps(({ plan }) => ({ dataForTabs: { plan } })),
)

const PlanSettings = ({
  history,
  history: {
    location: { search },
  },
  dirty,
  match: {
    params: { date, scale, planId },
  },
  dataForTabs,
}) => {
  const tabConfig = {
    createTitle: `Создание плана`,
    editTitle: `Редактирование плана`,
    closeUrl: `${PLANS_URL}/${planId}/calendar/${scale}/${date}${search || ``}`,
    basicUrl: `${PLANS_URL}/`,
    tabs: [
      {
        name: `Общая информация`,
        to: PLANS_ID_CALENDAR_MAIN_URL,
        id: `main`,
        date,
        scale,
        search,
        component: Item,
      },
      {
        name: `Управление ресурсами`,
        to: PLANS_ID_CALENDAR_RESOURCES_URL,
        id: `resources`,
        date,
        scale,
        search,
        component: PlanResourcesModal,
      },
      {
        name: `Ограничения`,
        to: PLANS_ID_CALENDAR_CONSTRAINT_URL,
        id: `constraint`,
        date,
        scale,
        search,
        component: Constraints,
      },
    ],
  }
  return (
    <TabsCrudModal
      paramsId={planId}
      dirty={dirty}
      history={history}
      tabConfig={tabConfig}
      dataForTabs={dataForTabs}
      id={planId}
    />
  )
}

PlanSettings.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
    location: PropTypes.object,
  }).isRequired,
  planId: PropTypes.string.isRequired,
  dirty: PropTypes.bool,
}

PlanSettings.defaultProps = {
  dirty: false,
}

export default enhancer(PlanSettings)
